// Reducer for the WhatsApp pairing-session cluster. These four pieces of state
// describe one thing — the live wacli session and its group list — and are
// updated together by the polling effects and the pair/unpair handlers. Grouping
// them removes the separate-render churn react-doctor/prefer-useReducer flags.

export const initialWaState = {
    session: null,         // current session blob from the bridge (or null)
    sessionLoading: false, // a session poll is in flight
    groups: [],            // WhatsApp groups for the paired account
    groupsRefreshing: false, // a groups fetch is in flight
};

export function waSessionReducer(state, action) {
    switch (action.type) {
        case 'SET_FIELD':
            return { ...state, [action.field]: action.value };
        default:
            return state;
    }
}
